import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { MODAL_KEYS } from '_constants/modals';
import { theme } from '_constants/theme';
import { selectData, selectLoading } from '_store/billing/selector';
import { getPaymentMethods } from '_store/billing/slice';
import { showModal } from '_store/modals/slice';
import { selectCustomerId } from '_store/user/selector';

import Card from 'components/atomic/layouts/Card';
import Text from 'components/atomic/layouts/Text';

import PaymentMethodsList from './PaymentMethodsList';

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spaces.small}px;
`;

const StyledBody = styled.div``;

const BillingInfoView = () => {
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);

  const handlePaymentMethodModalAdd = () => {
    dispatch(showModal({ key: MODAL_KEYS.paymentMethodAdd }));
  };

  useEffect(() => {
    if (customerId) {
      dispatch(getPaymentMethods({ customerId }));
    }
  }, [customerId]);

  return (
    <Card>
      <StyledHeader>
        <Text size={theme.fontSizes.medium} weight={600}>
          Billing Information
        </Text>
      </StyledHeader>
      <StyledBody>
        <PaymentMethodsList loading={loading} items={data} onAdd={handlePaymentMethodModalAdd} />
      </StyledBody>
    </Card>
  );
};

export default BillingInfoView;
